import { Form, FormListOperation } from 'antd';
import { FC, useMemo, useState } from 'react';
import { ExtractTagSelect } from '../../../components/extract-tag-select';
import { AreaExtractionCheckbox } from '../../_base/components/area-extraction-checkbox';
import { ExtractTagSelectItem } from '../../../components/extract-tag-select/select';
import { IconFont, Ternary } from '@/components';
import { cn, createPromise } from '@/utils';
import useExtractTags from '../../../components/extract-tag-select/use-extract-tags';
import { useSpecificAreaId } from '@/pages/CustomCenter/ExtractConfig/stores/use-specifc-area-id';
import { useTab } from '@/pages/CustomCenter/ExtractConfig/stores/useTab';
import { useStore } from '../../../store';
import { useQueryClient } from '@umijs/max';
import { QUERY_KEYS } from '@/pages/CustomCenter/ExtractConfig/type';
import { Field } from './type';

const StyleItem = Form.Item;

export const FieldItem: FC<{
  field: Field;
  prefix: (string | number)[];
  fullPrefix: (string | number)[];
  operation: FormListOperation;
  readonly?: boolean;
  node_id: string;
  activeField: number;
  setActiveField: (key: number) => void;
}> = ({
  field,
  prefix,
  fullPrefix,
  operation,
  readonly,
  node_id,
  activeField,
  setActiveField,
}) => {
  const form = Form.useFormInstance();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { findTag, selectOptions } = useExtractTags();
  const tagCode: string = Form.useWatch([...fullPrefix, 'tag_code']);
  const emitter = useStore((s) => s.eventEmitter);
  const queryClient = useQueryClient();
  const status = Form.useWatch([...fullPrefix, 'specify_regional_status']);

  const [_, setTab] = useTab();
  const [currentNodeId, setCurrentNodeId] = useSpecificAreaId();

  const tag = useMemo(
    () => findTag(tagCode, selectOptions),
    [tagCode, findTag, selectOptions],
  );

  return (
    <div
      key={field.key}
      onClick={() => {
        setActiveField(field.key);
      }}
      className={`relative  hover:shadow mb-4 p-2  border border-[#E5E7EC]
       rounded-md transition ${field.key === activeField ? 'bg-[#f6f9ff]' : 'bg-white'} `}
    >
      <div className="-top-2 right-2 absolute flex items-center gap-2">
        <IconFont
          onClick={() => setIsCollapsed(!isCollapsed)}
          type={isCollapsed ? 'icon-zhankaikapian' : 'icon-shouqikapian'}
          style={{
            cursor: 'pointer',
            transform: isCollapsed ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.3s',
          }}
        />
        <IconFont
          className={cn({
            'cursor-not-allowed pointer-events-none': readonly,
          })}
          // onClick={() => onDelete?.(field.name)}
          onClick={() => {
            if (readonly) return;
            operation.remove(Number(prefix[0]));
          }}
          type="icon-liebiaoshibai"
        />
      </div>

      <div>
        <div style={{ display: isCollapsed ? 'none' : 'block' }}>
          <div>
            <Form.Item label="字段" name={[...prefix, 'tag_code']}>
              <ExtractTagSelectItem acceptedTypes={['hand_writing']} />
            </Form.Item>

            <StyleItem
              name={[...prefix, 'specify_regional_config']}
              valuePropName="checked"
            >
              <AreaExtractionCheckbox
                onRedirect={async () => {
                  if (readonly) return;
                  const { promise, resolve } = createPromise();
                  emitter?.emit({
                    type: 'SWITCH_TAB',
                    payload: {
                      resolve,
                    },
                  });
                  await promise;

                  queryClient.refetchQueries({
                    queryKey: [QUERY_KEYS.SPECIFIC_AREA],
                  });

                  setCurrentNodeId(node_id);
                  setTab('SPECIFIC_AREA');
                }}
                showRedirect={!readonly}
                status={status}
                onChange={(checked) => {
                  if (checked) {
                    form.setFieldValue(
                      [...fullPrefix, 'specify_regional_status'],
                      0,
                    );
                  } else {
                    // clear
                    form.setFieldValue(
                      [...fullPrefix, 'specify_regional_status'],
                      undefined,
                    );
                  }
                }}
              />
            </StyleItem>

            <Form.Item
              hidden
              name={[...prefix, 'specify_regional_status']}
            ></Form.Item>
          </div>
        </div>
        <div
          style={{ display: isCollapsed ? 'flex' : 'none' }}
          className="justify-between items-center gap-2"
        >
          <Ternary
            condition={Boolean(tag)}
            falseElement={<span className="text-slate-400">未选择字段</span>}
          >
            <Ternary
              condition={tag?.type === 'text'}
              falseElement={
                <div className="space-x-1">
                  <span>{tag?.parent_label}</span>
                  <span className="font-bold">{tag?.label}</span>
                </div>
              }
            >
              <span className="font-bold">{tag?.label}</span>
            </Ternary>
          </Ternary>
        </div>
      </div>
    </div>
  );
};
